export const assemblyTypes = [
  'RP',
  'RPDA',
  'RPDA_2',
  'DC',
  'DCDA',
  'DCDA_2',
  'TYPE_2_BYPASS',
  'PVB',
  'SVB',
  'AVB',
  'AIR_GAP',
];

export const assemblySizes = [
  { decimal: 0.25, fraction: '1/4"' },
  { decimal: 0.375, fraction: '3/8"' },
  { decimal: 0.5, fraction: '1/2"' },
  // { decimal: .625, fraction: '5/8"' },
  { decimal: 0.75, fraction: '3/4"' },
  { decimal: 1, fraction: '1"' },
  { decimal: 1.25, fraction: '1 1/4"' },
  { decimal: 1.5, fraction: '1 1/2"' },
  // { decimal: 1.75, fraction: '1 3/4"' },
  { decimal: 2, fraction: '2"' },
  { decimal: 2.5, fraction: '2 1/2"' },
  { decimal: 3, fraction: '3"' },
  { decimal: 4, fraction: '4"' },
  // { decimal: 5, fraction: '5"' },
  { decimal: 6, fraction: '6"' },
  { decimal: 8, fraction: '8"' },
  { decimal: 10, fraction: '10"' },
  { decimal: 12, fraction: '12"' },
];
